import styled from 'styled-components';
export var Wrapper = styled.div.withConfig({
  displayName: "Playerstyles__Wrapper",
  componentId: "sc-az6i8o-0"
})(["position:relative;width:100%;z-index:", ";background-color:", ";box-shadow:", ";grid-area:player / player / player / player;display:grid;height:4rem;grid-template:'wave wave' 0px 'info controls' 1fr / 1fr 1fr;padding:0.5rem 1rem;-webkit-box-align:center;align-items:center;", "{height:4.5rem;padding:0 2rem;align-items:center;justify-items:center;gap:2rem;grid-template-areas:'info controls wave volume';grid-template-columns:auto auto 1fr auto;grid-template-rows:72px;}"], function (props) {
  return props.theme.zIndexes.navigation;
}, function (props) {
  return props.theme.colors.backgroundPrimary;
}, function (props) {
  return props.theme.shadows["default"];
}, function (props) {
  return props.theme.breakpoints.tablet;
});
export var Controls = styled.div.withConfig({
  displayName: "Playerstyles__Controls",
  componentId: "sc-az6i8o-1"
})(["display:flex;grid-area:controls;align-items:center;justify-content:flex-end;height:48px;", "{justify-content:center;}"], function (props) {
  return props.theme.breakpoints.tablet;
});
export var PlayButton = styled.button.withConfig({
  displayName: "Playerstyles__PlayButton",
  componentId: "sc-az6i8o-2"
})(["display:flex;justify-content:center;align-items:center;background-color:", ";height:2.5rem;width:2.5rem;border:0px;border-radius:50%;color:inherit;cursor:pointer;font-family:inherit;padding:0px;&:focus:not(:focus-visible){outline:none;}"], function (props) {
  return props.disabled ? props.theme.colors.uiDisabled : props.theme.colors.ui1;
});
export var Button = styled.button.withConfig({
  displayName: "Playerstyles__Button",
  componentId: "sc-az6i8o-3"
})(["display:flex;justify-content:center;align-items:center;height:2rem;width:2rem;border:0px;color:inherit;cursor:pointer;font-family:inherit;padding:0px;margin:0.5rem;background:none;&:focus:not(:focus-visible){outline:none;}"]);
export var VolumeWrapper = styled.div.withConfig({
  displayName: "Playerstyles__VolumeWrapper",
  componentId: "sc-az6i8o-4"
})(["grid-area:volume;display:none;height:48px;", "{display:flex;align-items:center;justify-content:flex-end;}"], function (props) {
  return props.theme.breakpoints.tablet;
});